/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Encoding } from "./Encoding";
import * as t from "io-ts";

// required attributes
const CreditorInstitutionEncodingsR = t.interface({
  encodings: t.readonlyArray(Encoding, "array of Encoding")
});

// optional attributes
const CreditorInstitutionEncodingsO = t.partial({});

export const CreditorInstitutionEncodings = t.intersection(
  [CreditorInstitutionEncodingsR, CreditorInstitutionEncodingsO],
  "CreditorInstitutionEncodings"
);

export type CreditorInstitutionEncodings = t.TypeOf<
  typeof CreditorInstitutionEncodings
>;
